<template>
  <div>
    <loading :active.sync="isLoading" color="#85344c"></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
        <ol class="breadcrumb">
          <li class="breadcrumb-item active">Marketing</li>
        </ol>

        <div class="row">
          <div class="col-md-12" v-if="mostraErro">
            <div class="alert alert-danger alert-dismissible" role="alert">
              <button
                type="button"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <strong>Ops!</strong>
              <span>{{ erroMensagem }}</span>
            </div>
          </div>
        </div>

        <div class="row m-1">
          <div class="col-md-12">
            <div class="form-check">
              <input
                type="checkbox"
                :checked="showOptions"
                @change="(e) => (showOptions = e.target.checked)"
                class="form-check-input"
                id="exampleCheck1"
              />
              <label class="form-check-label" for="exampleCheck1"
                >Permitir que o popup seja exibido.</label
              >
            </div>
          </div>
        </div>

        <v-card v-if="showOptions">
          <v-card-title
            >Configurações do popup
            <v-spacer></v-spacer>
          </v-card-title>
          <div class="row p-3">
            <div class="col-md-6">
              <textarea class="w-100" v-model="content" id="" rows="10"></textarea>
            </div>
            <div class="col-md-6">
              Preview:
              <div v-html="content"></div>
            </div>
          </div>
        </v-card>

        <div class="row">
          <div class="col-md-12">
            <p>
              <button
                href="#0"
                @click="savePopup"
                class="btn_1 medium pull-right mt-3"
              >
                Salvar
              </button>
            </p>
          </div>
        </div>
        <ol class="breadcrumb mt-3">
          <li class="breadcrumb-item active">Newsletter</li>
        </ol>
        <v-card>
          <v-card-title
            >Lista de e-mails
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Filtrar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table :headers="headers" :items="emailList" :search="search">
            <template slot="items" slot-scope="props">
              <td>{{ props.item.id }}</td>
              <td>{{ props.item.email }}</td>
              <td>{{ props.item.ultima_pagina }}</td>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
              >Sua consulta para "{{ search }}" não teve resultado.</v-alert
            >
          </v-data-table>
        </v-card>
        <div class="row">
          <div class="col-md-12">
            <p>
              <button
                href="#0"
                @click="exportEmails"
                class="btn_1 medium pull-right mt-3 mb-3"
              >
                Exportar dados
              </button>
            </p>
          </div>
        </div>
      </div>
      <!-- /container-fluid-->
    </div>
  </div>
</template>

<script>
import { ajax, tratamento_requisicao, alerta } from "@/utils/util";
import funcoesGerais from "@/assets/js/funcoes.js";
import { VueEditor } from "vue2-editor";
import axios from "axios";
import xlsx from "json-as-xlsx";

export default {
  mixins: [funcoesGerais],
  data() {
    return {
      isLoading: false,
      showOptions: false,
      content: "",
      search: "",
      erroMensagem: "",
      mostraErro: false,
      emailList: [],
      headers: [
        { text: "Id", value: "id" },
        { text: "Email", value: "email" },
        { text: "Ultima Página", value: "ultima_pagina" },
      ],
    };
  },
  components: {
    VueEditor,
  },
  methods: {
    savePopup() {
      let self = this;
      self.isLoading = true;

      ajax("post", `/operadoras/${this.$route.params.id}/marketing`, {
        popup_habilitado: this.showOptions,
        popup_texto: this.content,
      })
        .then((response) => {
          self.isLoading = false;
          alerta(
            "success",
            "Sucesso!",
            "Os Dados do popup foram salvos com sucesso!"
          );
        })
        .catch((error) => {
          self.isLoading = false;
          alerta("error", "Erro!", "Erro ao salvar dados do popup!");
        });
    },
    exportEmails() {
      var columns = [
        { label: "Data de Criação", value: "created_at" },
        { label: "Id", value: "id" },
        { label: "Email", value: "email" },
        { label: "Provider", value: "provider_id" },
        { label: "Ultima Pagina Visitada", value: "ultima_pagina" },
        { label: "Data de atualização", value: "updated_at" },
      ];

      var content = this.emailList;

      var settings = {
        sheetName: "Newsletter",
        fileName: "Newsletter",
        extraLength: 3,
        writeOptions: {},
      };

      var download = true;

      xlsx(columns, content, settings, download);
    },
  },

  created() {
    let self = this;
    self.isLoading = true;

    axios
      .all([
        axios.get(`/operadoras/${this.$route.params.id}/marketing`),
        axios.get(`/operadoras/${this.$route.params.id}/newsletter`),
      ])
      .then(
        axios.spread((marketingRes, newsletterRes) => {
          self.isLoading = false;
          if (Object.entries(marketingRes.data).length > 0) {
            this.showOptions =
              marketingRes.data.popup_habilitado == 1 ? true : false;
            this.content = marketingRes.data.popup_texto;
            this.emailList = newsletterRes.data;
          }
        })
      )
      .catch((e) => {
        alert(e);
      });
  },
};
</script>